if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // dataset 属于元素自身属性，constructor 中可安全访问
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        // 先确认子节点可用；若尚未挂载（极端情况）则不设标记，等下次 connect 重试
        this.form = this.querySelector('form');
        if (!this.form) return;

        // 防止 disconnect/reconnect 场景下重复绑定 submit 事件
        if (this._initialized) return;
        this._initialized = true;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const $scope = $(this.form).closest('.shokz-main-product-content-wrapper');
        const $checkedGiftBenefits = $scope.find('.benefit-wrapper.buy-x-get-y:not(.hidden)');

        if ($checkedGiftBenefits.length > 0) {
          // 纯展示赠品栏（display-only）/ 赠品不可售的栏本身不可勾选，不能把主商品行标成
          // 「PDP 已选赠品行」，否则买赠规则（如 BOGO）会把这行排除在父商品之外，赠品不会带出
          let hasSelectableGiftBar = false;
          $checkedGiftBenefits.each(function () {
            const $wrapper = $(this);
            if ($wrapper.hasClass('display-only')) {
              return;
            }
            const $productWrapper = $wrapper.find('.product-wrapper');
            if ($productWrapper.length === 0 || $productWrapper.find('.checkbox').length === 0) {
              return;
            }
            hasSelectableGiftBar = true;
            if (!$productWrapper.hasClass('active')) {
              return;
            }
            if ($productWrapper.find('.sold-out-text').length > 0) {
              return;
            }
            if ($wrapper.find('.prices').text().trim().toUpperCase() === 'SOLD OUT') {
              return;
            }
            if (window.__giftPairSoldOut) {
              return;
            }
            const giftVariantId = $wrapper.data('id');
            if (giftVariantId) {
              formData.append(`properties[_G_${giftVariantId}]`, '1');
            }
          });
          // 只有存在「可勾选」的赠品栏时才按 PDP 行处理（保留取消勾选赠品的语义）；
          // 全部是纯展示栏时不打标记，买赠规则才能正常自动带出赠品
          if (hasSelectableGiftBar) {
            formData.append('properties[_G_FromPdp]', '1');
          }
        } else if (
          typeof window.isExclusiveMainVariantId === 'function' &&
          window.isExclusiveMainVariantId(variantId)
        ) {
          formData.append('properties[_G_FromPdp]', '1');
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              // Assertive live region ensures the error is announced even when
              // the role="alert" wrapper's hidden-toggle is unreliable on some SRs.
              if (typeof window.announceCartStatus === 'function') {
                window.announceCartStatus(
                  typeof window.getCartFailedMessage === 'function'
                    ? window.getCartFailedMessage(response.description)
                    : `Failed to add to cart. ${response.description || 'Please try again.'}`,
                  null,
                  { assertive: true }
                );
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (typeof window.announceCartStatus === 'function') {
              window.announceCartStatus(
                typeof window.getCartFailedMessage === 'function'
                  ? window.getCartFailedMessage()
                  : 'Failed to add to cart. Please try again.',
                null,
                { assertive: true }
              );
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, flag = 0) {
        const discontinuedIds = (this.submitButton.getAttribute('discontinued-id') || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
        const variantId = this.querySelector('.product-variant-id')?.value || '';
        // 没有对应变体时 id 为空，不能当成停产；空字符串 indexOf 恒为 0，会把后续正确组合的文案锁死
        const isDiscontinued = variantId !== '' && discontinuedIds.includes(variantId);
        if (disable) {
         
          if (flag == 1) {
            this.submitButton.setAttribute('data-disabled', 1);
          }
          this.submitButton.setAttribute('disabled', 'disabled');
          if (isDiscontinued) {
            this.submitButtonText.textContent = 'Discontinued'
          } else if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.setAttribute('data-disabled', 0);
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;

          // if (location.pathname == '/products/opendots-one' && this.submitButton.getAttribute('data-pre-id').indexOf(new URLSearchParams(window.location.search).get('variant')) > -1) {
          //   this.submitButtonText.textContent = 'Pre-order';
          //   this.querySelector('.pre_order_tip')?.classList.remove('hidden')
          //   $('.product-form__buttons .product-form__submit').attr('data-capitalize', '')
          // }
          // else {
          //   this.querySelector('.pre_order_tip')?.classList.add('hidden')
          //   this.submitButton.removeAttribute('data-capitalize')
          //   $('.product-form__buttons .product-form__submit').removeAttr('data-capitalize')
          // }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}